import type { RankedTester } from '@jsonforms/core';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import type { LayoutProps } from '@jsonforms/core';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';

function SectionLabelComponent({ uischema, visible }: LayoutProps) {
  if (!visible) return null;

  const text = (uischema as any).text || '';

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 500 }}>
        {text}
      </Typography>
      <Divider sx={{ mt: 0.5 }} />
    </Box>
  );
}

export const SectionLabelRenderer = withJsonFormsLayoutProps(
  SectionLabelComponent,
);
